<template>
  <v-card>
    <a-data-table
      :headers="headers"
      :items="meetingTypesData"
      :page.sync="page"
      :items-per-page="5"
      dense
      class="elevation-1"
      :no-data-text="$t('noData')"
      :loading-text="$t('LoaderText')"
      mobile-breakpoint="0"
    >
      <template v-slot:[`header.meeting_type_id`]="{ header }">
        <span class="header-text"> {{ header.text }}</span>
      </template>
      <template v-slot:[`header.role`]="{ header }">
        <span class="header-text"> {{ header.text }} </span>
      </template>
      <template v-slot:item.meeting_type_id="{ item }">
        <span> {{ getmeetingTypeName(item.meeting_type_id) }} </span>
      </template>
      <template v-slot:item.role="{ item }">
        <v-select
          :disabled='!isPhotoUploading'
          class="role-select mt-0"
          dense
          :items="userRoleList"
          v-model="item.role_id"
          hide-details=""
          item-text="role"
          item-value="role_id"
          :menu-props="{ bottom: true, offsetY: true }"
          :placeholder="$t('admin.lblNotAssigned')"
          @focus="focusRoles($event, item.meeting_type_id)"
          :ref="`refMeetingTypeRoles${item.meeting_type_id}`"
        ></v-select>
      </template>
    </a-data-table>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { cloneDeep } from "lodash";

export default {
  name: "MeetingTypePermissionList",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isPhotoUploading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      page: 1,
    };
  },
  computed: {
    ...mapState({
      roleList: (state) => state.admin.roleList,
    }),
    ...mapGetters({
      meetingTypes: "tenant/agendaMeetingTypes",
    }),
    headers() {
      return [
        {
          text: this.$t("admin.lblMeetingType"),
          align: "start",
          sortable: false,
          value: "meeting_type_id",
          width: "50%",
        },
        {
          text: this.$t("admin.lblMeetingBasedRoles"),
          value: "role",
          class: "header",
        },
      ];
    },
    userRoleList() {
      let roleList = this.roleList.filter(
        (r) => r.role_type === "meeting_type"
      );
      let roleItems = cloneDeep(roleList);
      roleItems.unshift({
        id: null,
        role: this.$t("admin.lblNotAssigned"),
      });
      return roleItems.map((role) => {
        return { role_id: role.id, role: role.role };
      });
    },
    meetingTypesData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || []);
      },
    },
  },
  methods: {
    getmeetingTypeName,
    focusRoles(e, meetingType) {
      this.scrolling(e.srcElement, meetingType);
    },
    scrolling(element, meetingType) {
      let dialogCardEl = document.getElementById("dialog-card-text")
      if(dialogCardEl) {
        dialogCardEl.addEventListener("scroll", (event) => {
          this.$refs[`refMeetingTypeRoles${meetingType}`].blur();
        })
      }
    },
  },
};

function getmeetingTypeName(id) {
  const meetingType = this.meetingTypes.find((item) => item.id === id);
  if (meetingType) {
    return meetingType.label;
  }
  return "Not found";
}
</script>

<style scoped>
.role-select /deep/ .v-select__selections {
  line-height: 21px !important;
}
.role-select /deep/ .v-input__slot:before {
  border-style: none !important;
  border-width: 0 0 0 0 !important;
}
.role-select /deep/ .v-input__slot:after {
  border-style: none !important;
  border-width: 0 0 0 0 !important;
}
tr.v-data-table__selected {
  background: #7d92f5 !important;
}
</style>